// deployment_class: customer_env_allowed
/**
 * Executive cockpit — the suggested-question seeds for Ask Kathedral.
 *
 * These are the starter prompts shown as chips in the cockpit Ask panel and the
 * inline Drill. Each is a REAL question sent to the governed `POST /v3/ai/ask`
 * pipeline through the shared client (`web/v3/src/shell/ai/useAskKathedral.ts`) —
 * there are NO canned answers anywhere
 * ([[feedback_no_canned_ai_replies_ever_all_real_researched_never_hedge_2026_08_01]]).
 *
 * The prior demo-canned `ANSWERS` lookup table + `answer()` helper (retired
 * 2026-08-03 · Wave 3 of the customer-AI de-can) is preserved for the change-trail
 * at `docs/archive/dashboard-canned-ask-answers.md` (GOD rule — copied, never
 * deleted).
 */
/**
 * These name no project and no agency, deliberately.
 *
 * They read "Why is the Phoenix gate at risk?" and "Show Willow's distribution
 * waterfall" until 2026-09-01 — chips offering every customer a question about
 * a deal that is not theirs and does not exist in their database. A starter
 * prompt has to work on day one, for an agency whose own projects Kathedral has
 * never seen, so each one asks about a CLASS of thing the product knows about
 * and lets the answer name the specifics.
 */
export const SUGGESTED: string[] = [
  'Which gates are at risk right now?',
  "Draft my talking points for Thursday's board",
  'Show me a distribution waterfall',
  "Which deals slip if I don't act this week?",
];
